import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";
import { CONSTANT } from "../../config/Constant";

export const getRoles = createAsyncThunk(
  "Role/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();

      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          // If the value is an array, append each item with the same key
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          // For non-array values, just append normally
          params.append(key, value);
        }
      }
      const queryString = params.toString();

      const { data } = await axios.get(`${API_URL.ROLE.SLUG}?${queryString}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createRole = createAsyncThunk(
  "Role/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${API_URL.ROLE.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteRole = createAsyncThunk(
  "Role/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(`${API_URL.ROLE.SLUG}/${id}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editRole = createAsyncThunk(
  "Role/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(`${API_URL.ROLE.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const getRoleRightData = createAsyncThunk(
  "Role/getRoleRightData",
  async (payload, { rejectWithValue }) => {
    const URL = `${API_URL.ROLE.ROLE_RIGHT_EDIT}${payload.roleId === undefined ? "" : `?roleId=${payload.roleId}`}${payload.roleTypeId === undefined ? "" : `?roleTypeId=${payload.roleTypeId}`}`
    try {
      const { data } = await axios.get(URL);
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCreateRoleRightData = createAsyncThunk(
  "Role/getCreateRoleData",
  async(payload, { rejectWithValue}) => {
    const URL = `${API_URL.ROLE.ROLE_RIGHT_CREATE}${payload.roleId === undefined ? "" : `?roleId=${payload.roleId}`}${payload.roleTypeId === undefined ? "" : `?roleTypeId=${payload.roleTypeId}`}`;
    try {
      const { data } = await axios.get(URL);
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
)

export const saveRoleRightData = createAsyncThunk(
  "Role/saveRoleRightData",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${API_URL.ROLE.ROLE_RIGHT}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const roleSlice = createSlice({
  name: "role",
  initialState: {
    backOffice_role_list: [],
    current_values: null,
    active_payload: null,
    total_records: 0,
    role_loading: false,
    role_right_data: null
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },

    resetCurrentValue(state) {
      state.current_values = null;
      state.role_right_data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRoles.fulfilled, (state, action) => {
      state.backOffice_role_list = action.payload.data.list;
      state.total_records = action.payload.data.totalRecords || 0;
    });
    builder
      .addCase(getRoleRightData.pending, (state) => {
        state.role_loading = true;
      })
      .addCase(getRoleRightData.fulfilled, (state, action) => {
        state.role_right_data = action.payload;
        state.role_loading = false;
      })
      .addCase(getRoleRightData.rejected, (state) => {
        state.role_loading = false;
        state.role_right_data = null;
      })
      .addCase(getCreateRoleRightData.pending, (state) => {
        state.role_loading = true;
      })
      .addCase(getCreateRoleRightData.fulfilled, (state, action) => {
        state.role_right_data = action.payload;
        state.role_loading = false;
      })
      .addCase(getCreateRoleRightData.rejected, (state) => {
        state.role_loading = false;
        state.role_right_data = null;
      });
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } = roleSlice.actions;
export default roleSlice.reducer;
